export const rp = (n) => {
  if (!n && n !== 0) return "";
  return "Rp" + new Intl.NumberFormat("id-ID").format(Number(n));
};

export const rpShort = (n) => {
  if (!n && n !== 0) return "";
  if (n >= 1_000_000) return "Rp" + (n / 1_000_000).toFixed(1).replace(".0", "") + "jt";
  if (n >= 1000) return "Rp" + Math.round(n / 1000) + "rb";
  return "Rp" + n;
};

/** Format any number with Indonesian thousand separator (no currency prefix). */
export const fmtDigits = (n) => {
  if (!n && n !== 0) return "";
  return new Intl.NumberFormat("id-ID").format(Number(n));
};

/** Strip thousand separators / spaces from a raw string, return integer or null. */
export const parseDigits = (s) => {
  if (s == null) return null;
  const digits = String(s).replace(/[^\d]/g, "");
  if (!digits) return null;
  return parseInt(digits, 10);
};

/** Convert THB (baht) to IDR using given rate (IDR per 1 THB). */
export const thbToIdr = (thb, rate) => Math.round(Number(thb) * Number(rate || 0));
/** Convert IDR to THB — returns 0 if rate not set. */
export const idrToThb = (idr, rate) => (rate && rate > 0 ? Number(idr) / Number(rate) : 0);

/** Display THB in Thai baht style — "฿1,250" */
export const bahtStr = (n) => {
  if (!n && n !== 0) return "";
  const rounded = Math.round(Number(n));
  return "฿" + new Intl.NumberFormat("th-TH").format(rounded);
};

export const stockLabel = (s) => ({
  ready: "READY",
  preorder: "PREORDER",
  sold_out: "HABIS",
}[s] || s);

export const stockColor = (s) => ({
  ready: "bg-mint-400/95 text-plum",
  preorder: "bg-babyblue-400/95 text-plum",
  sold_out: "bg-neutral-200/95 text-plum/60",
}[s] || "");

/** cloudinary thumb transform (if url is cloudinary) */
export const thumb = (url, w = 800) => {
  if (!url) return "";
  if (url.includes("res.cloudinary.com") && url.includes("/upload/")) {
    return url.replace("/upload/", `/upload/w_${w},f_auto,q_auto/`);
  }
  return url;
};

/** cloudinary tiny blurred placeholder (LQIP) ~2KB — instant paint */
export const lqip = (url) => {
  if (!url) return "";
  if (url.includes("res.cloudinary.com") && url.includes("/upload/")) {
    return url.replace("/upload/", `/upload/w_40,e_blur:1000,q_auto:low,f_auto/`);
  }
  return "";
};
